import React from 'react';
import { Box, Card, CardHeader, CardContent, Stack } from '@mui/material';

import Scrollbar from '../../../../../components/Scrollbar';
import { ActivityForm } from './ActivityForm';

export const FullScreenView = props => {
  const { data, submitCallback, handleClose, allResorts, allSeasons, allTypes, allPeriods, allCategories } = props;

  return (
    <Scrollbar>
      <Box display="flex" flexDirection="row" justifyContent="space-between" mt={1} mr={2}>
        <Stack flex="1 1 70%">
          <Card>
            <CardHeader title={data ? 'Edytuj zajęcie' : 'Dodaj zajęcie'} sx={{ mt: -1, mb: -2 }} />
            <CardContent>
              <ActivityForm
                data={data}
                submitCallback={submitCallback}
                handleClose={handleClose}
                allResorts={allResorts}
                allSeasons={allSeasons}
                allTypes={allTypes}
                allPeriods={allPeriods}
                allCategories={allCategories} />
            </CardContent>
          </Card>
        </Stack>
      </Box>
    </Scrollbar>
  );
};
